import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  alignItems: "center",
  gap: "$lg",
  flexWrap: "wrap",
  flexGrow: 1
});